import feathersClient, { makeServicePlugin, BaseModel } from '@/plugins/feathers-client'

class MilestoneSlideshow extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'MilestoneSlideshow'
  // Define default properties here
  static instanceDefaults() {
    return {
    }
  }
}
const servicePath = 'milestone/slideshow'
const servicePlugin = makeServicePlugin({
  Model: MilestoneSlideshow,
  service: feathersClient.service(servicePath),
  servicePath,
  namespace: 'milestone-slideshow'
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin